/* Bocetta v4.5 · Compra en celular. Lo carga snippets/bocetta-idioma-region.liquid (en el <head>) con defer.
   1. Ficha: en celular la galería abre en la primera foto del color, no en el 3D (el 3D sigue en la miniatura «3D»).
      Al deslizar sobre el 3D la libreta gira en vez de pasar de foto, por eso se quedaba «atorada» en él.
   1b. Ficha: barra fija de compra (en celular y, desde v4.5.1, también en escritorio).
   2. Portada: el botón de Chat se esconde mientras el hero está a la vista (tapaba el titular).
   3. Selector de región e idioma de la cabecera: abre y cierra la hoja.
   4. Portada (escritorio, v4.5.2): la barra fija de los cuatro colores se esconde mientras se ven las tarjetas de colores. */
(function () {
  var celular = matchMedia('(max-width: 749px)');
  var raiz = document.documentElement;

  /* ---------- 1 · Galería: primera foto ---------- */
  /* Huella de la galería: la imagen de la segunda diapositiva (cambia con el color). La galería se vuelve a
     acomodar solo cuando cambia; así, si el visitante toca la miniatura «3D», no lo regresamos a la foto
     aunque el visor agregue elementos a la galería. */
  function huella(slides) {
    var img = slides[1] && slides[1].querySelector('img');
    return (img && (img.getAttribute('src') || img.currentSrc)) || String(slides.length);
  }

  function primeraFoto(galeria) {
    if (!celular.matches || !galeria) return;
    var slides = galeria.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;
    var variante = huella(slides);
    if (galeria.dataset.bc45Foto === variante) return;
    var primera = slides[0];
    if (!primera.matches('.product-media-container--model') && !primera.querySelector('product-model, .bc4-galeria3d')) return;
    galeria.dataset.bc45Foto = variante;
    customElements.whenDefined('slideshow-component').then(function () {
      /* Horizon regresa la galería al inicio después de cambiar de color: esperamos a que termine */
      setTimeout(function () {
        requestAnimationFrame(function () {
          var ss = galeria.querySelector('slideshow-component');
          if (!ss || typeof ss.select !== 'function') return;
          var activa = galeria.querySelector('slideshow-slide[aria-hidden="false"]');
          if (activa && activa !== galeria.querySelector('slideshow-slide')) return;
          var x = window.scrollX, y = window.scrollY;
          try { ss.select(1, undefined, { animate: false }); } catch (e) {}
          /* select() no debe mover la página */
          if (window.scrollY !== y) window.scrollTo(x, y);
        });
      }, 150);
    });
  }

  function revisarGalerias() {
    document.querySelectorAll('.product-information__media media-gallery').forEach(primeraFoto);
  }

  if (raiz.dataset.bc4Plantilla === 'product' || document.querySelector('.product-information__media')) {
    revisarGalerias();
    /* Al cambiar de color Horizon vuelve a pintar las diapositivas: se vuelve a revisar */
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        if (cambios[i].addedNodes.length) { revisarGalerias(); return; }
      }
    }).observe(document.querySelector('.product-information__media') || document.body, { childList: true, subtree: true });
  }

  /* ---------- 1b · Barra fija de compra ----------
     Horizon (assets/sticky-add-to-cart.js) no la muestra nunca si la tienda tiene Shopify Inbox (el chat),
     y además solo aparece después de pasar el botón. Aquí la manejamos: se ve siempre que el botón principal
     no está en pantalla (en celular también al abrir la ficha, cuando el botón aún está más abajo) y se esconde
     al llegar al pie. Solo cambia data-stuck, el mismo atributo que usa Horizon; el chat sube con CSS.
     v4.5.1: también en escritorio (ahí el botón queda arriba al cargar, así que la barra sale al bajar). */
  function barraCompra() {
    var bloque = document.querySelector('.product-information .buy-buttons-block');
    var pie = document.querySelector('footer');
    if (!bloque || !('IntersectionObserver' in window)) return;
    var botonVisible = true;
    var pieVisible = false;
    var aplicar = function () {
      var barra = document.querySelector('.sticky-add-to-cart__bar');
      if (!barra) return;
      barra.dataset.stuck = (!botonVisible && !pieVisible) ? 'true' : 'false';
    };
    new IntersectionObserver(function (es) {
      botonVisible = es[es.length - 1].isIntersecting;
      aplicar();
    }).observe(bloque);
    if (pie) {
      new IntersectionObserver(function (es) {
        pieVisible = es[es.length - 1].isIntersecting;
        aplicar();
      }, { rootMargin: '200px 0px 0px 0px' }).observe(pie);
    }
  }
  if (document.querySelector('sticky-add-to-cart')) barraCompra();

  /* ---------- 2 · Chat fuera del hero ---------- */
  var hero = document.querySelector('bocetta-v4-hero');
  if (hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      raiz.classList.toggle('bc45-chat-fuera', celular.matches && e.isIntersecting && e.intersectionRatio > 0.25);
    }, { threshold: [0, 0.25, 0.5, 1] }).observe(hero);
  }

  /* ---------- 4 · Barra de colores fuera de «Nuestros colores» ----------
     La barra repetía las mismas cuatro tarjetas que ya estaban en pantalla y tapaba el contenido de abajo. */
  var tarjetas = document.querySelector('bocetta-v4-colores');
  if (tarjetas && document.querySelector('[data-bc4-barra]') && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      raiz.classList.toggle('bc45-sin-barra', es[es.length - 1].isIntersecting);
    }, { rootMargin: '-20% 0px -20% 0px' }).observe(tarjetas);
  }

  /* ---------- 3 · Selector de región e idioma ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target instanceof Element ? ev.target : null;
    if (!t) return;
    var abrir = t.closest('[data-bc45-region-abrir]');
    if (abrir) {
      var hoja = document.getElementById(abrir.getAttribute('aria-controls'));
      if (hoja && typeof hoja.showModal === 'function') {
        ev.preventDefault();
        hoja.showModal();
        abrir.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (t.closest('[data-bc45-region-cerrar]') || (t.matches('dialog.bc45-hoja'))) {
      var d = t.closest('dialog.bc45-hoja');
      if (d) d.close();
    }
  });
  document.addEventListener('close', function (ev) {
    var d = ev.target;
    if (!(d instanceof HTMLDialogElement) || !d.classList.contains('bc45-hoja')) return;
    var b = document.querySelector('[data-bc45-region-abrir][aria-controls="' + d.id + '"]');
    if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
  }, true);
})();
